import styled from "styled-components";

export const CardImportFileContainer = styled.label<{ colorBack: string, width: number }>`
  background-color: ${(props) =>
    props.colorBack !== "" ? props.colorBack : "#fee2e2"};
    width: ${(props) => props.width > 0 ? `${props.width}px` : '300px'};
    height: 60px;
    border-radius: 10px;
    border: dashed 2px #b91c1c;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    
`;
